// ---------------------------------------------------------------------------
// Column data
// ---------------------------------------------------------------------------

export interface StripPlotColumnData {
  readonly name: string;
  readonly data: number[];
}

// ---------------------------------------------------------------------------
// Params
// ---------------------------------------------------------------------------

export interface StripPlotParams {
  readonly columns: StripPlotColumnData[];
}

// ---------------------------------------------------------------------------
// Display
// ---------------------------------------------------------------------------

export interface StripPlotDisplayConfig {
  readonly dotColor?: string;
  readonly dotSize?: number;
}

export const DEFAULT_STRIP_PLOT_DISPLAY: StripPlotDisplayConfig = {
  dotColor: '#6366f1', // indigo-500
  dotSize: 7,
};
